import script from "./Other.vue?vue&type=script&setup=true&lang=js"
export * from "./Other.vue?vue&type=script&setup=true&lang=js"

import "./Other.vue?vue&type=style&index=0&id=b30adb6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b30adb6a"]])

export default __exports__